import { Box, BoxProps, Chip, Skeleton, Stack, styled, Typography } from '@razz-team/ui-web';
import { ApiCardDesign } from '../../../openapi';

interface CardProps extends BoxProps {
  status?: string;
  lastFour?: string | null | undefined;
  holderName: string | null | undefined;
  cardDesign: ApiCardDesign | null | undefined;
}

const width = 1280 / 4;
const height = 804 / 4;

const StyledCard = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundSize: 'cover',
  padding: '18px 16px',
  borderRadius: 8,
  alignSelf: 'center',
  transition: theme.transitions.create('background-image'),
  width,
  height,
}));

export function Card({ status, holderName, lastFour, cardDesign, ...props }: CardProps) {
  if (!cardDesign) {
    return <Skeleton variant="rounded" width={width} height={height} />;
  }

  const textColor = cardDesign.foregroundPrimaryColor;

  return (
    <StyledCard
      {...props}
      sx={{
        backgroundImage: cardDesign.image ? `url(${cardDesign.image})` : undefined,
        backgroundColor: cardDesign.backgroundColor,
        ...props.sx,
      }}
    >
      {status ? (
        <Chip label={status} size="small" sx={{ position: 'absolute', top: 20, right: 20 }} />
      ) : null}
      <Stack spacing={1} position="absolute" bottom={20} left={20}>
        <Typography sx={{ color: textColor }} variant="subtitle1">
          {holderName}
        </Typography>
        {lastFour ? (
          <Typography sx={{ color: textColor }} variant="subtitle1">
            {`••${lastFour}`}
          </Typography>
        ) : null}
      </Stack>
    </StyledCard>
  );
}
